import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import type { Maybe } from '@/lib/types';

import { visibilityControl } from '../../Card.styles';

export const Wrapper = styled(Box)<{
  $visibleInDesktop?: Maybe<boolean>;
  $visibleInMobile?: Maybe<boolean>;
  contentAlignment: string;
}>`
  width: 100%;
  display: flex;
  flex-direction: column;
  ${({ $visibleInDesktop, $visibleInMobile }) => css`
    ${visibilityControl($visibleInDesktop, $visibleInMobile)}
  `};
  ${({ contentAlignment, theme }) => css`
    ${theme.media.md.up} {
      position: relative;
      flex-direction: row;
      justify-content: ${contentAlignment === 'left'
        ? 'flex-end'
        : 'flex-start'};
    }
  `}
`;

export const InnerWrapper = styled(Box)`
  width: 100%;
  display: flex;
  flex-direction: column;
  ${({ theme }) => css`
    ${theme.media.md.up} {
      width: 88%;
      flex-direction: row;
    }
  `}
`;

export const ImageWrapper = styled(Box)`
  width: 100%;
  aspect-ratio: 1.179;
  position: relative;
  ${({ theme }) => css`
    ${theme.media.md.up} {
      aspect-ratio: 20 / 17;
    }
    ${theme.media.sm.down} {
      height: 291px;
    }
  `}
`;
export const TextWrapper = styled(Box)<{ contentAlignment: string }>`
  background-color: #ffc72c;
  opacity: 0.8;
  flex-grow: 1;
  max-height: 180px;
  overflow: hidden;
  ${({ contentAlignment, theme }) => css`
    padding: ${theme.spacing(2)};
    ${theme.media.md.up} {
      padding: ${({ theme }) => theme.spacing(3)};
      max-height: 303px;
      position: absolute;
      bottom: 0;
      ${contentAlignment === 'left' ? `left: 0` : `right: 0`};
      width: 278px;
    }
  `};
`;

export const Title = styled(Box)`
  font-weight: 600;
  ${({ theme }) =>
    css`
      font-family: ${theme.fontFamilies.italianPlate};
      font-size: ${theme.fontSizes.h4Mobile};
      margin-bottom: ${theme.spacing(1)};
      margin-left: ${theme.spacing(4)};
      ${theme.media.md.up} {
        margin-left: ${theme.spacing(0)};
      }
    `}
`;
export const Text = styled(Box)<{
  color: Maybe<string>;
  textAlignment: Maybe<string>;
}>`
  overflow: hidden;
  ${({ color, textAlignment, theme }) => css`
    font-size: ${theme.fontSizes.p2};
    font-weight: 400;
    line-height: 22px;
    font-family: ${theme.fontFamilies.openSans};
    color: ${color};
    text-align: ${textAlignment};
  `}
`;
